module.exports = __webpack_public_path__ + "static/media/ColorScheme.93905fa8.png";